<div class="form-group">
  <label for="onlyShowBillDatesSelect">Will the membership freeze on a bill date?</label>

  <select class="custom-select" id="onlyShowBillDatesSelect" name="onlyShowBillDatesSelect"
          [(ngModel)]="onlyShowBillDates" (ngModelChange)="effectiveDate = null; effectiveDaysFromNow = null;">
    <option [ngValue]="true">Yes</option>
    <option [ngValue]="false">No</option>
  </select>

  <small class="form-text text-muted">
    If a date other than a bill date is chosen, the number of days until the next bill date will be saved and added onto the membership when it is eventually unfrozen.
  </small>
  <small class="form-text text-muted">
    If "No" is selected, the Effective Date may be set to a past date, in which case the freeze will be backdated.
  </small>
</div>

<div class="form-group" *ngIf="onlyShowBillDates">
  <label>Effective Date</label>

  <div class="form-check" *ngFor="let upcomingBillDate of membership.upcoming_bill_dates">
    <input class="form-check-input" type="radio"
           name="effectiveDate" id="effectiveDate{{ upcomingBillDate }}"
           [(ngModel)]="effectiveDate" (ngModelChange)="updateEffectiveDaysFromNow()"
           [value]="upcomingBillDate">
    <label class="form-check-label" for="effectiveDate{{ upcomingBillDate }}">
      {{ dateStringFromISO8601(upcomingBillDate) }}
    </label>
  </div>
</div>

<div class="form-group" *ngIf="!onlyShowBillDates">
  <label for="effectiveDateManualInput">Effective Date</label>

  <app-date-picker [id]="'effectiveDateManualInput'"
                   [(content)]="effectiveDate"
                   (contentChange)="updateEffectiveDaysFromNow()"></app-date-picker>
</div>

<div class="form-group">
  <label for="unfreezeDateInput">Unfreeze Date (optional)</label>

  <app-date-picker [id]="'unfreezeDateInput'"
                   [(content)]="unfreezeDate"></app-date-picker>
</div>

<div class="form-group" *ngIf="orgConfigService.getOrganizationConfig().require_membership_freeze_reason">
  <label for="reasonSelect">Freeze Reason</label>
  <select class="custom-select"
          name="reason" id="reasonSelect"
          [(ngModel)]="reason">
    <option [ngValue]="null" disabled>---</option>
    <option *ngFor="let reasonOption of orgConfigService.getOrganizationConfig().membership_freeze_reason_options"
            [ngValue]="reasonOption">{{ reasonOption }}</option>
  </select>
</div>

<div class="alert alert-warning" *ngIf="effectiveDaysFromNow && (effectiveDaysFromNow > 30)">
  Your chosen effective date is {{ effectiveDaysFromNow }} days in the future. Please double check that this is correct before submitting.
</div>
<div class="alert alert-warning" *ngIf="effectiveDaysFromNow && (effectiveDaysFromNow >= -28) && (effectiveDaysFromNow < -7)">
  Your chosen effective date is {{ -effectiveDaysFromNow }} days in the past. Please double check that this is correct before submitting.
</div>
<div class="alert alert-danger" *ngIf="effectiveDaysFromNow && (effectiveDaysFromNow < -28)">
  Your chosen effective date is {{ -effectiveDaysFromNow }} days in the past. The effective date may not be more than 28 days ago.
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
